import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

/**
 * 分页查询模式切换记录
 */
export function switchPage(params) {
  const url = IhLogUrl + '/mode/switch/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('数据中心', '分页查询模式切换记录', res)
    }
    return Promise.resolve(res.data)
  })
}
// 模式记录批量删除
export function batchDeleteSwitch(params) {
  const url = IhLogUrl + '/mode/switch/batchDelete'
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('数据中心', '模式记录批量删除', res)
    }
    return Promise.resolve(res.data)
  })
}
/**
 * 模式记录删除
 */
export function switchDelete(params) {
  const url = IhLogUrl + '/mode/switch/delete'

  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('数据中心', '模式记录删除', res)
    }
    return Promise.resolve(res.data)
  })
}
